import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Status } from "@common/models";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class StatusService {
  private currentStatus: Status[] = [];
  private _onStatusChanged: BehaviorSubject<any>;

  constructor(private _http: HttpClient) {
    this._onStatusChanged = new BehaviorSubject(null);
  }

  get onStatusChanged(): Observable<any> {
    return this._onStatusChanged.asObservable();
  }

  /**
   * Función que obtiene todos los estados
   * @returns {Status[]} Devuelve un array de estados
   */
  getAll() {
    return this._http.get<Status[]>(`${environment.commonApiUrl}/api/status`);
  }

  /**
   * Register the provided status 
   */
  register() {
    this.getAll().subscribe((res) => {
      // Add to registry
      this.currentStatus = res;

      // Notify subject
      this._onStatusChanged.next(res);
    });
  }

  /**
   * Unregister the status from the registry
   *
   */
  unregister(): void {
    // Unregister sidebar
    delete this.currentStatus;

    // Notify subject
    this._onStatusChanged.next(null);
  }

  /**
   * Función que devuelve el estado por medio del código
   * @param {string} code Indica el código de estado
   * @returns {Status}
   */
  getStatusByCode(code: string): Status {
    // Busca el estado por medio del código
    const statuses = this.currentStatus.filter(
      (status) => status.code === code
    );

    // Devuelve el estado que encuentre con ese código
    return statuses?.length > 0 ? statuses[0] : null;
  }
}
